/**
 * Normaliza una cadena de texto
 * 
 * ```javascript
 * normalize('   GéNerO'); // Output: "genero"
 * ```
 * 
 * @param {string} string 
 * @returns {string}	
 */
export const normalize = (string) => {
    return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, '');
}